<template>
  <div class="row">
    <div class="col-xs-12 col-sm-6 col-md-4" v-for="(workflow, key) in workflows" v-bind:key="key">
      <div class="hpanel">
        <div class="panel-body" style="min-height: 330px;display: block" >
          <div class="text-center">
            <h3 class="m-b-xs"  style="min-height: 70px">{{workflow.name}}</h3>
            <div class="m">

              <i v-if="workflow.id === 1" class="fa-5x fa fa-book"></i>
              <i v-else-if="workflow.id === 2" class="fa-5x fa fa-question"></i>
              <i v-else-if="workflow.id === 3" class="fa-5x fa fa-euro"></i>
              <i v-else-if="workflow.id === 4" class="fa-5x fa fa-industry"></i>
            </div>
            <p class="small" style="min-height:47px">
              {{workflow.description}}
            </p>
            <div class="row">
              <div style="margin-top: 25px" class="col-xs-offset-3 col-xs-6">
                <template v-if="$user.isIdexlab() || ($user.isSme() && workflow.id !== 3)">
                  <button v-if="!workflow.enable" type="button" class="btn btn-info btn-outline btn-sm btn-block" @click="onWorkflowSelected('upgrade')">Upgrade Plan</button>
                  <button v-else type="button" class="btn btn-info btn-sm btn-block" @click="onWorkflowSelected(workflow)">Select</button>
                </template>
                <template v-else-if="$user.isSme() && workflow.id === 3">
                  <a href="mailto:sales@idexlab.com" v-if="!workflow.enable" type="button" class="btn btn-info btn-outline btn-sm btn-block" data-toggle="popover" >Contact us</a>
                  <button v-else type="button" class="btn btn-info btn-sm btn-block" @click="onWorkflowSelected(workflow)">Select</button>
                </template>
                <template v-else>
                  <button type="button" class="btn btn-info btn-sm btn-block" v-bind:class="{disabled : !workflow.enable}"
                          v-bind:disabled="!workflow.enable" @click="onWorkflowSelected(workflow)">Select</button>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="popover-wrong-plan" style="display: none">
      <div>You cannot create this type of project with your current plan</div>
      <div class="m-t-xs">You can enjoy this workflow as well as additional functionalities by migrating to ‘For Teams and Companies’ or ‘For Corporates’ plans.</div>
      <div class="m-t-xs text-center">Please contact us.</div>
    </div>
  </div>
</template>

<style>
</style>

<script>

export default {
  props: ['workflows', 'workflowSelected'],
  name: 'WorkflowBox',
  methods: {
    onWorkflowSelected: function (workflow) {
      this.$emit('input', workflow)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/project/WorkflowBox.vue